import { VFC } from 'react'
import styled from 'styled-components'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import { flexCenter } from 'src/styles/mixins'
import {
  _menuicon,
  _profilegreen,
  trueblack,
  truewhite,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'

type AlertProps = {
  report: () => void
  content: string
}

const Alert: VFC<ModalProps<AlertProps>> = ({ close, report, content }) => {
  return (
    <Layout>
      <h2>決裁者対応に関する注意喚起</h2>
      <p>
        こちらは運営からのメッセージになります。問題の解決が確認できるまでご紹介優先度の低下や一部機能制限を行うことがございます。
      </p>
      <br />
      <p>
        ※問題の解決が報告されるとこちらのポップアップは今後表示されなくなります。
      </p>
      <AlertContents>
        <div>
          注意内容
          <p>{content}</p>
        </div>
      </AlertContents>
      <ModalButtons>
        <CancelButton onClick={close}>キャンセル</CancelButton>
        <ReportButton onClick={report}>問題の解決を報告する</ReportButton>
      </ModalButtons>
    </Layout>
  )
}

export const AlertModal = asModal(Alert, { scrollable: true })

const Layout = styled.div`
  ${flexCenter};
  flex-direction: column;
  max-width: min(80vw, 480px);
  padding: 5%;
  border-radius: 12px;
  background-color: ${truewhite};
  line-height: 1.3rem;

  h2 {
    width: 100%;
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: ${fontWeightBold};

    @media screen and (max-width: 540px) {
      font-size: 15px;
    }
  }

  p {
    @media screen and (max-width: 540px) {
      font-size: 10px;
      line-height: 1rem;
    }
  }
`

const ModalButtons = styled.div`
  display: flex;
  width: 100%;
  margin-top: 20px;
  justify-content: flex-end;

  button {
    width: 100%;
    text-align: center;
    padding: 10px 20px;
    padding: 6px 12px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: ${fontWeightBold};
    line-height: 1.4;
    white-space: normal;
  }

  @media screen and (max-width: 540px) {
    display: block;
  }
`

const ReportButton = styled.button`
  color: ${truewhite};
  background: ${_profilegreen};
`

const CancelButton = styled.button`
  color: ${_profilegreen};
`

const AlertContents = styled.div`
  width: 100%;
  div {
    color: ${_menuicon};
    margin-top: 20px;
    padding: 10px;
    text-align: left;
    border: solid 1px;
    border-radius: 5px;
    p {
      font-size: 12px;
      line-height: 1.5;
      white-space: pre-wrap;
      color: ${trueblack};
      font-weight: ${fontWeightBold};
      height: 200px;
      overflow: auto;
      overflow: scroll;

      @media screen and (max-width: 540px) {
        height: 100px;
      }
    }
  }
`
